
import dayjs from "dayjs"
// import NP from "number-precision"
import { Drawer } from "element-ui"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import sHeader from "@/components/sheader.vue"
import payment from "@/components/checkout/payment"
import { showGlobalMessage, clientKeyMap } from "@/utils/utils"
import { calcPromotion } from "@/api/middle.js"
import paymentMixin from "@/mixins/payment"

export default {
  components: {
    sHeader,
    payment,
    [Drawer.name]: Drawer,
    drawerHeader
  },
  mixins: [paymentMixin],
  layout: "onlyFooter",
  props: {},
  data() {
    return {
      loading: false,
      payItemInfoList: [],
      countDown: 0,
      signNum: "",
      timer: null
    }
  },
  computed: {
    countDownShowText() {
      return dayjs(this.countDown).format("mm:ss")
    },
    canPay() {
      return !!this.paymentMethod
    },
    paymentDiscountAmount() {
      const key = this.paymentMethod
        ? `${this.paymentMethod.paymentMethodId}_${this.paymentMethod.signNum || "null"}`
        : ""
      return this.payMethodsPromo && key ? this.payMethodsPromo[key]?.promoDiscountAmount || 0 : 0
    }
  },
  watch: {},
  async created() {
    document.title = this.$t("pageTitle.cashier")
    const query = this.$route.query
    if (query && Object.keys(query).length) {
      this.orderNo = query.orderNo
      this.orderList = query.orderList
      try {
        this.loading = true
        await this.initPaymentSDK({
          merchantId: query.venderId
        })
        await this.calcPromotion()
        this.renderPaymentMethods()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    } else {
      this.$navigation.push({
        path: "/cart"
      })
    }
  },
  destroyed() {
    if (this.paymentMethodUI) {
      this.paymentMethodUI.destroy()
    }
  },
  methods: {
    renderPaymentMethods() {
      this.paymentMethodUI = this.$sdk.showPaymentMethods({
        container: "#payment-methods-container",
        payMethodsPromo: this.payMethodsPromo,
        selectMethod: this.paymentMethod,
        onSelect: result => {
          this.paymentMethod = result
          this.calcPromotion()
        },
        onError: function (error) {
          this.$message.error(error)
        }
      })
      this.setCountDownTimer()
    },
    async calcPromotion() {
      this.loading = true
      try {
        const res = await calcPromotion({
          orderId: this.orderNo,
          paymentMethod: this.paymentMethod?.paymentMethodId,
          X_Merchant_Id: this.curMerchantId,
          X_Client_Key: clientKeyMap[this.curMerchantId]
        })
        if (res.success) {
          this.payMethodsPromo = res.data
          this.salePrice = this.getPriceFromPromoList()
          const key = this.paymentMethod
            ? `${this.paymentMethod.paymentMethodId}_${this.paymentMethod.signNum || "null"}`
            : ""
          this.countDown = this.payMethodsPromo && key ? this.payMethodsPromo[key]?.autoCancelOrderSeconds || 0 : 0
        } else {
          this.$message.error(res.message)
        }
        return res.data
      } catch (error) {
        showGlobalMessage({
          message: `${error.msg || error.result || error.sourceMsg || this.$t("pendingPayment.payFail")}[${
            error.code
          }]`,
          gap: 150,
          iconClass: "messageWarning"
        })
      } finally {
        this.loading = false
      }
    },
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    setCountDownTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.countDown > 0) {
        this.timer = setInterval(() => {
          this.countDown = this.countDown - 1000

          if (this.countDown <= 0) {
            clearInterval(this.timer)
            this.$navigation.push({
              path: "/order_details",
              query: {
                orderId: this.orderNo
              }
            })
          }
        }, 1000)
      }
    }
  }
}
